var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M170.667 423.721H8.828A8.829 8.829 0 0 1 0 414.893V97.101a8.829 8.829 0 0 1 8.828-8.828h161.839v335.448z",
    fill: "#73af00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff4b55",
    d: "M170.67 88.277h170.67v335.45H170.67z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffe15a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.172 423.721H341.333V88.273h161.839A8.829 8.829 0 0 1 512 97.101v317.792a8.828 8.828 0 0 1-8.828 8.828zM257.833 223.641l7.584 22.741 23.971.185c1.857.014 2.627 2.385 1.133 3.488l-19.284 14.24 7.231 22.856c.561 1.771-1.455 3.235-2.967 2.155l-19.502-13.939-19.502 13.94c-1.511 1.08-3.527-.385-2.967-2.155l7.231-22.856-19.284-14.24c-1.494-1.103-.724-3.474 1.133-3.488l23.971-.185 7.584-22.741c.589-1.762 3.08-1.762 3.668-.001z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCm);
export default __webpack_public_path__ + "static/media/cm.54bafdf8e7995aa77988da7974f9f38e.svg";
export { ForwardRef as ReactComponent };